export default __webpack_public_path__ + "static/media/Transilluminator.5d131434.svg";